
<v-menu
    v-model                 = "menu"
    :offset-y               = "true"
    :close-on-content-click = "false"
    :max-height             = "height"
    content-class           = "dialog-border"
    nudge-bottom            = "6"
    bottom
>
    <template v-slot:activator="{ on, attrs }">
        <v-btn
            class  = "dialog-button"
            v-bind = "attrs"
            v-on   = "on"
            color  = "white"
            depressed
        >
            <div style="display: block">
                <div>
                    <v-icon color="primary" size="22">{{ icon }}</v-icon>
                </div>
                <div class="primary--text button-label">{{ label }}</div>
            </div>
        </v-btn>
    </template>

    <div class="white">
        <slot name="content" v-bind:open = "menu"></slot>
    </div>
</v-menu>
